export const Colors = {
    vampireBlack: "#02060C",
    vampireBlack15: "#02060C15",
    ateneoBlue: "rgba(19, 57, 114, 0)",
    slate75: "#36393E",
    lemonChiffon: "#FFF8E1",
    pumpkin: "#F57C00",
    lavenderBlush: "#FFEBEE",
    cinnabar: "#D32F2F",
    bubbles: "#E8F5E9",
    japaneselaurel: "#388E3C",
    dimGray: "#666666",
    scrim: "rgba(0, 0, 0, 0.5)",
    rust20: "rgba(193, 52, 5, 0.2)",
    lightOrange: "#FFEEE5",
};
